<template>
  <div></div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'StatusUpdater',
    data: () => ({
      candidateRunInformationInterval: null,
      candidateStatusInterval: null
    }),
    computed: {
      ...mapState({
        user: (state) => state.user.user,
        runState: (state) => state.run.runState || state.run?.runInformation.runState || 0
      })
    },
    watch: {
      runState() {
        this.checkRunState();
      }
    },
    methods: {
      checkRunState() {
        if (this.runState <= 2 || this.runState >= 5) {
          if (this.candidateStatusInterval) {
            clearTimeout(this.candidateStatusInterval)
            this.candidateStatusInterval = null;
          }
          this.$router.push({ name: 'blocker' })
          return;
        }
        if (!this.candidateStatusInterval) this.updateCandidateRegularly();
      },
      async updateInformationRegularly() {
        const self = this;
        await self.$api.run.getCandidateRuninformation()
        this.candidateRunInformationInterval = setTimeout(() => {
          this.updateInformationRegularly()
        }, 30000);
      },
      async updateCandidateRegularly() {
        const self = this;
        await self.$api.run.getCandidateStatus()
        this.candidateStatusInterval = setTimeout(() => {
          this.updateCandidateRegularly();
        }, 60000);
      }
    },
    mounted() {
      const self = this
      // initial loading - maybe we dont need that
      // self.$api.run.get(['candidate']);

      // aktive timer based refresh
      this.candidateStatusInterval = setTimeout(() => {
        self.updateCandidateRegularly();
      }, 60000)
      this.candidateRunInformationInterval = setTimeout(() => {
        self.updateInformationRegularly()
      }, 30000)

      // also check on mount if we are in a blockable runstate
      this.checkRunState();
    },
    beforeDestroy() {
      if (this.candidateStatusInterval) {
        clearTimeout(this.candidateStatusInterval);
        this.candidateStatusInterval = null;
      }
      if (this.candidateRunInformationInterval) {
        clearTimeout(this.candidateRunInformationInterval)
        this.candidateRunInformationInterval = null;
      }
    }
  };
</script>

<style scoped>

</style>
